import React, { Component } from 'react'
//import PropTypes from 'prop-types'
import Radium from 'radium'
import ReactSVG from 'react-svg'

import TELink from './../../../component/Navigation/TELink'
//import TENavLink from './../../../component/Navigation/TENavLink'

import images from './../../../config/images'
import styles from './styles'

class Navbar extends Component {
	constructor(props) {
		super(props)

		this.state = {
			mobileNavOpen : false
		}

		this.handleToggleNav 	= this.handleToggleNav.bind(this)
	}

	handleToggleNav(){
		this.setState({ mobileNavOpen: !this.state.mobileNavOpen })
	}

	render() {
		const { mobileNavOpen } = this.state

		return (
			<div style={styles.container}>
				<div style={styles.brandLogoWrapper}>
					<TELink to="/">
						<img src={images.logo} alt='logo' title='Rebel Analytics' style={styles.logo}/>
					</TELink>
				</div>
				<div style={styles.navContainer}>
					<ul style={styles.navUl}>
						<li style={[styles.navLi, mobileNavOpen && styles.liOpen]}>
							<a href="http://rebel-travel.com/about/" style={styles.link} key='about'>About</a>
						</li>
						<li style={[styles.navLi, mobileNavOpen && styles.liOpen]}>
							<a href="http://rebel-travel.com/partners/" style={styles.link} key='partners'>Partners</a>
						</li>
						<li style={[styles.navLi, mobileNavOpen && styles.liOpen]}>
							<a href="http://rebel-travel.com/blogs/" style={styles.link} key='blog'>Blogs</a>
						</li>
						<li style={[styles.navLi, mobileNavOpen && styles.liOpen]}>
							<a href="http://rebel-travel.com/contact-us/" style={styles.link} key='contact'>Contact Us</a>
						</li>
					</ul>
				</div>
				<button
					onClick={this.handleToggleNav}
					style={[
						styles.mobileNavButton,
						mobileNavOpen && styles.activeMobileNavButton
					]}
				>
					<ReactSVG
						path={images.navIcon}
						style={styles.navIcon}
					/>
				</button>
			</div>
		)
	}
}

Navbar.propTypes = {}

Navbar.defaultProps = {}

export default Radium(Navbar)



// WEBPACK FOOTER //
// ./src/layout/Front/Navbar/Navbar.js